// Thin, dependency-free fetch helpers. Same-origin in production (CloudFront
// serves the site and /api/* from the same domain); VITE_API_BASE lets a local
// preview point at the deployed backend (CORS is open).
const API = import.meta.env.VITE_API_BASE ?? ''

async function request(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    headers: body !== undefined ? { 'content-type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(text || `${method} ${path} failed (${res.status})`)
  }
  return res.json()
}

const get = (path) => request(path)
const post = (path, body = {}) => request(path, { method: 'POST', body })

export const getUsers = () => get('/api/users')
export const login = (user_id) => post('/api/login', { user_id })
export const getConfig = () => get('/api/config')
export const getScenarios = () => get('/api/scenarios')

export const postChat = ({ prompt, agent, sessionId, userId, override }) =>
  post('/api/chat', { prompt, agent, sessionId, userId, override })

export const postEvaluate = () => post('/api/evaluate', {})

export const createAgent = (payload) => post('/api/agents', payload)
export const verifyAgent = (payload) => post('/api/agents/verify', payload)
export const setAgentEnabled = (name, enabled) =>
  post(`/api/agents/${encodeURIComponent(name)}/${enabled ? 'enable' : 'disable'}`, {})
export const deleteAgent = (name) => post(`/api/agents/${encodeURIComponent(name)}/delete`, {})
